import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  Action_GetDMGroupCategories,
  Action_GetDMStore,
  Action_GetDMCategories,
  Action_GetDMCategories1,
  Action_GetDMCategoriesBaoGia,
  Action_GetDMGroupCustomers,
  Action_GetDMBank,
  Action_GetConfigByKey,
  Action_GetConfigAllSTKey,
  Action_GetThongTinFormIn,
} from "actions/DanhMuc/actionTypes";
import {
  Index_getDMGroupCategoriesSuccess,
  Index_getDMStoreSuccess,
  Index_GetDMCategoriesSuccess,
  Index_GetDMCategoriesSuccess1,
  Index_GetDMCategoriesBaoGiaSuccess,
  Index_GetDMGroupCustomersSuccess,
  Index_getDMBankSuccess,
  Index_getConfigByKeySuccess,
  Index_GetConfigAllSTKeySuccess,
  Index_GetThongTinFormInSuccess,
} from "actions/DanhMuc";
import danhmucApi from "service/danhmucApi";
import { pushNotification } from "utils/notifications";
import { CheckTokenReload } from "utils/utils";

//Region api
function* Saga_GetConfigAllSTKey(action) {
  try {
    const response = yield call(danhmucApi.getAllConfigSTKey, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetConfigAllSTKeySuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* Saga_getConfigByKey(action) {
  try {
    const response = yield call(danhmucApi.getConfigByKey, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_getConfigByKeySuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* Saga_getDMStore(action) {
  try {
    const response = yield call(danhmucApi.getDanhMucStore, action.payload);
    console.log("action.payload1111", action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_getDMStoreSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* Saga_getDMCategories(action) {
  try {
    const response = yield call(danhmucApi.getDanhMucCategory, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetDMCategoriesSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* Saga_getDMCategories1(action) {
  try {
    const response = yield call(danhmucApi.getDanhMucCategory1, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetDMCategoriesSuccess1(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}

function* Saga_getDMCategoriesBaoGia(action) {
  try {
    const response = yield call(
      danhmucApi.getDanhMucCategoryBaoGia,
      action.payload
    );
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetDMCategoriesBaoGiaSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
function* Saga_getDMGroupCustomers(action) {
  try {
    const response = yield call(danhmucApi.getDanhMucGroupCus, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetDMGroupCustomersSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}

function* Saga_getDMBank(action) {
  try {
    const response = yield call(danhmucApi.getDanhMucBank, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_getDMBankSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}

function* Saga_GetThongTinFormIn(action) {
  try {
    const response = yield call(danhmucApi.getThongTinFormIn, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_GetThongTinFormInSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
//endregion api
//region watchAPI

function* watch_GetDMStore() {
  yield takeLatest(Action_GetDMStore, Saga_getDMStore);
}
function* watch_GetDMCategories() {
  yield takeLatest(Action_GetDMCategories, Saga_getDMCategories);
}
function* watch_GetDMCategories1() {
  yield takeLatest(Action_GetDMCategories1, Saga_getDMCategories1);
}
function* watch_GetDMCategoriesBaoGia() {
  yield takeLatest(Action_GetDMCategoriesBaoGia, Saga_getDMCategoriesBaoGia);
}
function* watch_GetDMGroupCustomers() {
  yield takeLatest(Action_GetDMGroupCustomers, Saga_getDMGroupCustomers);
}
function* watch_GetDMBank() {
  yield takeLatest(Action_GetDMBank, Saga_getDMBank);
}
function* watch_GetConfigByKey() {
  yield takeLatest(Action_GetConfigByKey, Saga_getConfigByKey);
}
function* watch_GetConfigAllSTKey() {
  yield takeLatest(Action_GetConfigAllSTKey, Saga_GetConfigAllSTKey);
}
function* watch_GetThongTinFormIn() {
  yield takeLatest(Action_GetThongTinFormIn, Saga_GetThongTinFormIn);
}
//endregion watchAPI

export default function* sagas() {
  yield all([
    watch_GetDMStore(),
    watch_GetDMCategories(),
    watch_GetDMCategories1(),
    watch_GetDMGroupCustomers(),
    watch_GetDMBank(),
    watch_GetConfigByKey(),
    watch_GetConfigAllSTKey(),
    watch_GetDMCategoriesBaoGia(),
    watch_GetThongTinFormIn(),
  ]);
}
